<template>
	<b-modal v-model="isShowPopup" dialog-class="modal-detail" @hidden="resetModal" scrollable :no-close-on-backdrop=true @ok="addButtonAction" title="Add Data Approver State">
		<b-card>
			<b-col cols="12" lg="6">
				<app-input-combobox-autocomplete :options="approverTypes" optionsLabel="name" optionsKey="id" label-cols-sm="4" label-cols-lg="3" label="Approver Type" id="input-" size="sm" :model.sync="model.approverTypeId"   :selected="model.approverType != null ? model.approverType.name : ''" @input="getApproverTypes" />
				<app-input-combobox-autocomplete :options="approvalStructures" optionsLabel="name" optionsKey="id" label-cols-sm="4" label-cols-lg="3" label="Approval Structure" id="input-" size="sm" :model.sync="model.approvalStructureId"   :selected="model.approvalStructure != null ? model.approvalStructure.name : ''" @input="getApprovalStructures" />
				<app-input-textbox id="fieldset-approver-level" label-cols-sm="4" label-cols-lg="3" label="Approver Level" label-for="input-approver-level" size="sm" :model.sync="model.approverLevel"  />
				<app-input-combobox-autocomplete :options="userInfos" optionsLabel="firstName" optionsKey="userName" label-cols-sm="4" label-cols-lg="3" label="Approver User" id="input-" size="sm" :model.sync="model.approverUserId"   :selected="model.approverUser != null ? model.approverUser.firstName : ''" @input="getUserInfos" />
				<app-input-combobox-autocomplete :options="activityStates" optionsLabel="name" optionsKey="id" label-cols-sm="4" label-cols-lg="3" label="Activity State" id="input-" size="sm" :model.sync="model.activityStateId"   :selected="model.activityState != null ? model.activityState.name : ''" @input="getActivityStates" />
				<app-input-combobox-autocomplete :options="approvalConfigurationInstanceDetails" optionsLabel="approverType" optionsKey="id" label-cols-sm="4" label-cols-lg="3" label="Approval Configuration Detail" id="input-" size="sm" :model.sync="model.approvalConfigurationInstanceDetailId"   :selected="model.approvalConfigurationInstanceDetail != null ? model.approvalConfigurationInstanceDetail.approverType : ''" @input="getApprovalConfigurationInstanceDetails" />
				<app-input-textbox id="fieldset-sequence" label-cols-sm="4" label-cols-lg="3" label="Sequence" label-for="input-sequence" size="sm" :model.sync="model.sequence"  />
				<app-input-textbox id="fieldset-stored-procedure-name" label-cols-sm="4" label-cols-lg="3" label="Stored Procedure Name" label-for="input-stored-procedure-name" size="sm" :model.sync="model.storedProcedureName"  />
				<b-form-group id="fieldset-is-send-notification" label-cols-sm="4" label-cols-lg="3" label="Is Send Notification" label-for="input-is-send-notification">
						<b-form-checkbox id="input-is-send-notification" v-model="model.isSendNotification"></b-form-checkbox>
					</b-form-group>
			</b-col>
		</b-card>
		<b-overlay :show="isBusy" no-wrap></b-overlay>
	</b-modal>
</template>
<style lang="scss" scoped>
	::v-deep .modal-dialog {
		width: 70% !important; 
	}
</style> 
<script>
import axios from 'axios';
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import ApproverState from '@/models/ApprovalInstance/ApproverState';
import ApproverStateFilter from '@/filters/ApprovalInstance/ApproverStateFilter';

import ApprovalInstance from '@/models/ApprovalInstance/ApprovalInstance';
import ApprovalInstanceFilter from '@/filters/ApprovalInstance/ApprovalInstanceFilter';
import AppInputComboboxAutocomplete from '@/components/AppInputComboboxAutocomplete';
import ApproverType from '@/models/ApproverType/ApproverType';
import ApproverTypeFilter from '@/filters/ApproverType/ApproverTypeFilter';
import ApprovalStructure from '@/models/ApprovalStructure/ApprovalStructure';
import ApprovalStructureFilter from '@/filters/ApprovalStructure/ApprovalStructureFilter';
import AppInputTextbox from '@/components/AppInputTextbox';
// import UserInfo from '@/models/PrivilegeManagement/UserInfo';
// import UserInfoFilter from '@/filters/PrivilegeManagement/UserInfoFilter';
import ActivityState from '@/models/ActivityState/ActivityState';
import ActivityStateFilter from '@/filters/ActivityState/ActivityStateFilter';
import ApprovalConfigurationInstanceDetail from '@/models/ApprovalConfigurationInstance/ApprovalConfigurationInstanceDetail';
import ApprovalConfigurationInstanceDetailFilter from '@/filters/ApprovalConfigurationInstance/ApprovalConfigurationInstanceDetailFilter';
import PopupRouterView from '@/components/PopupRouterView';
export default {
	props: ['modelId', 'openPopup','addButtonMethod', 'resetMethod'],
	components : {AppInputComboboxAutocomplete,AppInputTextbox,PopupRouterView,},
	mixins : [validationMixin],
	validations: {
		model: {
		}
	},
	data() {
		return {
			model : {},
			errorMessage : {
			},
			approverTypes : [],
			approvalStructures : [],
			userInfos : [],
			activityStates : [],
			approvalConfigurationInstanceDetails : [],
			isBusy: false,
		}
	},
	methods : {
		getApproverState : async function(id) {
			this.isBusy = true;
			ApproverState.getData(this, id).then(result => { this.model = result; this.isBusy = false }).catch(error => { this.isBusy = false; });
		},
		getApproverTypes : async function(input) {
			let filter = new ApproverTypeFilter();
			if (input != undefined) {
				filter.name = input;
			}
			ApproverType.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.approverTypes = result.data
				}
			})
			.catch(error => {});
		},
		getApprovalStructures : async function(input) {
			let filter = new ApprovalStructureFilter();
			if (input != undefined) {
				filter.name = input;
			}
			ApprovalStructure.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.approvalStructures = result.data
				}
			})
			.catch(error => {});
		},
		getUserInfos : async function(input) {
			let filter = new UserInfoFilter();
			if (input != undefined) {
				filter.firstName = input;
			}
			UserInfo.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.userInfos = result.data
				}
			})
			.catch(error => {});
		},
		getActivityStates : async function(input) {
			let filter = new ActivityStateFilter();
			if (input != undefined) {
				filter.name = input;
			}
			ActivityState.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.activityStates = result.data
				}
			})
			.catch(error => {});
		},
		getApprovalConfigurationInstanceDetails : async function(input) {
			let filter = new ApprovalConfigurationInstanceDetailFilter();
			if (input != undefined) {
				filter.approverType = input;
			}
			ApprovalConfigurationInstanceDetail.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.approvalConfigurationInstanceDetails = result.data
				}
			})
			.catch(error => {});
		},
		validateState(name) {
			const { $dirty, $error } = this.$v.model[name];
			return $dirty ? !$error : null;
		},
		getErrorMessage(message, name) {
			if (this.$v.model[name].required != undefined && !this.$v.model[name].required) {
				if (message.required) return message.required;
			}
		},
		addButtonAction(modalEvent) {
			modalEvent.preventDefault();

			this.$v.model.$touch(); 
			if (this.$v.model.$anyError) {
				return;
			} else {
				this.$emit("addButtonMethod", modalEvent, this.model); 
			}
		},
		resetModal() {
			this.$emit('resetMethod');
		},
	},
	beforeMount() {
		this.getApproverTypes();
		this.getApprovalStructures();
		this.getUserInfos();
		this.getActivityStates();
		this.getApprovalConfigurationInstanceDetails();
	},
	async mounted(){
	},
	watch : {
		modelId(newValue) {
			if (newValue != null && newValue != undefined && newValue != '') {
				this.getApproverState(newValue);
			} else {
				this.model = {};
			}
		},
		openPopup(newValue) {
			if (newValue) {
				this.getApproverTypes();
				this.getApprovalStructures();
				this.getUserInfos();
				this.getActivityStates();
				this.getApprovalConfigurationInstanceDetails();
			} else {
				this.model = {};
			}
		}
	},
	computed: {
		isShowPopup : {
			get: function () {
				if (this.openPopup) return true;
				else return false;
			},
			set: function (newValue) {}
		},
	}
}
</script>
